module.exports = __webpack_public_path__ + "static/media/info-3.886fbf85.png";